<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">账套管理</span></div>
		<div class="margin-top margin-left">
			<Button color="primary" @click="showForm=true">新建账套</Button>
			<Button @click="$router.push('/setting/backup')">备份记录</Button>&nbsp;&nbsp;当前账套数量为{{datas.length}}个&nbsp;&nbsp;
		</div>
		<div class="h-panel-body">
			<Table :datas="datas" :border="true">
				<TableItem :width="80" align="center">
					<template slot-scope="{data}">
						<span class="h-tag h-tag-bg-green" v-if="data.id == User.accountSetsId">当前</span>
					</template>
				</TableItem>
				<TableItem title="ID" prop="id" :width="80"></TableItem>
				<TableItem title="单位名称" prop="companyName"></TableItem>
				<TableItem title="统一社会信用代码" prop="creditCode" :width="180"></TableItem>
				<TableItem title="当前记账年月" prop="currentAccountDate" :width="120" :format="dateFormat"></TableItem>
				<TableItem title="账套启用年月" prop="enableDate" :width="120" :format="dateFormat"></TableItem>
				<TableItem title="会计准则" prop="accountingStandards" dict="accountingStandards" :width="200"></TableItem>
				<TableItem title="账套模板" prop="accountTemplate" dict="accountTemplate" :width="240"></TableItem>
				<TableItem title="创建人" prop="creatorName" :width="100"></TableItem>
				<TableItem title="角色" prop="roleType" dict="roles" :width="100"></TableItem>
				<TableItem title="创建时间" prop="createDate" :width="150" :format="dateTimeFormat"></TableItem>
				<TableItem title="凭证审核" prop="voucherReviewed" dict="enableRadios" :width="100"></TableItem>
				<TableItem title="状态" :width="80">
					<span slot-scope="{data}">{{data.status == 0 ? '正常' : '不可用'}}</span>
				</TableItem>
				<TableItem title="操作" :width="220" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="grant(data)">授权</span>
						<span @click="openRenew(data)">续期</span>
						<span @click="toggleEnable(data)">{{data.status == 1 ? '启用' : '停用'}}</span>
						<span @click="openReset(data)">重置</span>
						<span @click="edit(data)">编辑</span>
						<span @click="remove(data)" v-if="User.role === 'Manager'">删除</span>
					</div>
				</TableItem>
			</Table>
		</div>
		<Modal v-model="showForm" type="drawer-right" hasCloseIcon>
			<div slot="header">创建账套</div>
			<Form ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
				<FormItem label="账套名称:" prop="companyName">
					<input type="text" v-model="form.companyName">
				</FormItem>
				<FormItem label="账套启用年月:" prop="enableDate">
					<DatePicker type="month" v-model="form.enableDate" :disabled="used"/>
				</FormItem>

				<FormItem label="账套模板:" prop="accountTemplate">
					<Select v-model="form.accountTemplate" dict="accountTemplate" :disabled="!!form.id"></Select>
				</FormItem>
				<FormItem label="会计准则:" prop="accountingStandards">
					<Radio v-model="form.accountingStandards" dict="accountingStandards" :disabled="!!form.id"></Radio>
				</FormItem>
				<FormItem label="增值税种类:" prop="vatType">
					<Radio v-model="form.vatType" dict="vatRadios" :disabled="!!form.id"></Radio>
				</FormItem>
				<FormItem label="统一社会信用代码:" prop="creditCode">
					<input type="text" v-model="form.creditCode">
				</FormItem>

				<FormItem label="凭证现金流平衡检查:" prop="cashFlowBalanceCheck">
					<Radio v-model="form.cashFlowBalanceCheck" dict="cashFlowBalanceCheck"></Radio>
				</FormItem>
				<FormItem label="凭证是否需要审核:" prop="voucherReviewed">
					<Radio v-model="form.voucherReviewed" dict="needRadios"></Radio>
				</FormItem>
				<FormItem label="制单人与审核人可为同一人:" prop="reviewSameUser">
					<Radio v-model="form.reviewSameUser" dict="enableRadios" disabled></Radio>
				</FormItem>
			</Form>
			<div class="text-center">
				<Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'创建'}}账套</Button>
				<Button @click="showForm=false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="showModal" hasCloseIcon>
			<div slot="header">删除账套</div>
			<div>
				<div>您正在删除账套：<b>{{rmData.companyName}}</b><br>为保障数据安全，需要短信验证身份。</div>
				<Row type="flex" :space="10" class="margin">
					<Cell><input type="text" v-model="User.mobile" disabled></Cell>
					<Cell>
						<SmsVerificationCode :mobile="User.mobile"/>
					</Cell>
				</Row>
				<Row type="flex" :space="10" class="margin">
					<Cell><input v-model="msgCode" type="number" placeholder="请输入验证码"></Cell>
				</Row>
			</div>
			<div class="text-center">
				<Button color="red" :disabled="!this.msgCode" @click="doRemove" :loading="loading">删除</Button>
				<Button @click="showModal=false">取消</Button>
			</div>
		</Modal>

		<!-- 用户授权抽屉 -->
		<Modal v-model="showGrant" type="drawer-right" hasCloseIcon>
			<div slot="header">{{grantData.companyName}} - 用户授权</div>
			<Form v-width="420" mode="twocolumn" :labelWidth="120" :model="grantForm">
				<FormItem label="用户手机号:">
					<input type="text" v-model="grantForm.mobile" placeholder="已注册用户手机号">
				</FormItem>
				<FormItem label="角色:">
					<Select v-model="grantForm.role" dict="roles"></Select>
				</FormItem>
			</Form>
			<div class="text-center">
				<Button color="primary" @click="doGrant" :loading="loading">授权</Button>
				<Button @click="showGrant=false">取消</Button>
			</div>
		</Modal>

		<!-- 续期 -->
		<Modal v-model="showRenew" hasCloseIcon>
			<div slot="header">账套续期</div>
			<div>
				<p>账套：<b>{{renewData.companyName}}</b></p>
				<p>当前到期日：{{renewData.expiredAt || '未设置'}}</p>
				<Form v-width="360" :labelWidth="100" :model="renewForm">
					<FormItem label="顺延(月):">
						<input type="number" v-model="renewForm.months" min="1">
					</FormItem>
				</Form>
			</div>
			<div class="text-center">
				<Button color="primary" @click="doRenew" :loading="loading">确认续期</Button>
				<Button @click="showRenew=false">取消</Button>
			</div>
		</Modal>

		<!-- 重置（清空业务数据，需短信验证） -->
		<Modal v-model="showReset" hasCloseIcon>
			<div slot="header">重置账套</div>
			<div>
				<p class="text-warn">将清空账套 <b>{{resetData.companyName}}</b> 的全部凭证/明细/结账业务数据，<b>保留科目模板、报表与用户授权</b>。此操作不可恢复！</p>
				<Row type="flex" :space="10" class="margin">
					<Cell><input type="text" :value="User.mobile" disabled></Cell>
					<Cell><Button @click="sendResetCode" :loading="codeLoading">发送验证码</Button></Cell>
				</Row>
				<Row type="flex" :space="10" class="margin">
					<Cell><input v-model="resetCode" type="number" placeholder="请输入短信验证码"></Cell>
				</Row>
			</div>
			<div class="text-center">
				<Button color="red" :disabled="!resetCode" @click="doReset" :loading="loading">确认重置</Button>
				<Button @click="showReset=false">取消</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import {getTotalData} from '../../js/locations/district';
	import moment from 'moment';
	import {mapState} from 'vuex';
	import SmsVerificationCode from "../../components/SmsVerificationCode";

	const emptyForm = {
		"accountTemplate": "",
		"accountingStandards": "0",
		"vatType": "0",
		"companyName": "",
		"creditCode": "",
		"enableDate": null,
		"cashFlowBalanceCheck": "0",
		"voucherReviewed": "0",
		"reviewSameUser": "0"
	};

	export default {
		name: 'Account',
		components: {SmsVerificationCode},
		data() {
			return {
				datas: [],
				pickerOption: {
					keyName: 'id',
					titleName: 'title',
					dataMode: 'list',
					parentName: 'parentId',
					datas: getTotalData()
				},
				form: Object.assign({}, emptyForm),
				validationRules: {
					required: ["companyName", "enableDate", "accountTemplate", "accountingStandards", "vatType", "cashFlowBalanceCheck", "voucherReviewed"]
				},
				showModal: false,
				rmData: {},
				msgCode: '',
				showForm: false,
				used: false,
				loading: false,
				// 用户授权
				showGrant: false,
				grantData: {},
				grantForm: {mobile: '', role: 'Making'},
				// 续期
				showRenew: false,
				renewData: {},
				renewForm: {months: 12},
				// 重置
				showReset: false,
				resetData: {},
				resetCode: '',
				codeLoading: false
			};
		},
		watch: {
			showForm(val) {
				if (!val) {
					this.reset();
				}
			},
			'form.accountTemplate'(val) {
				this.onTemplateChange(val);
			}
		},
		computed: {
			...mapState(["User"])
		},
		methods: {
			loadList() {
				this.$api.setting.accountSets.list().then(({data}) => {
					this.datas = data || [];
				})
			},
			submit() {
				let validResult = this.$refs.form.valid();
				if (validResult.result) {
					this.loading = true;
					this.form.enableDate = moment(this.form.enableDate).format("YYYY-MM-DD");
					this.$api.setting.accountSets[this.form.id ? 'update' : 'save'](this.form).then(() => {
						this.$store.dispatch('init');
						this.loadList();
						this.showForm = false;
						this.loading = false;
					}).catch(() => {
						this.loading = false;
					})
				}
			},
			reset() {
				this.form = Object.assign({}, emptyForm);
				this.used = false;
			},
			dateFormat(val) {
				return val ? moment(val).format("YYYY年MM月") : '';
			},
			dateTimeFormat(val) {
				return val ? moment(val).format("YYYY-MM-DD HH:mm") : '';
			},
			onTemplateChange(val) {
				if (!val) {
					return;
				}
				// 与后端 ACCOUNT_TEMPLATE_MAP 保持一致：自动带出会计准则与增值税种类
				const map = {
					"SME_NPV_SMALL": [0, 0], "SME_NPV_GENERAL": [0, 1],
					"ENT_NPV_SMALL": [1, 0], "ENT_NPV_GENERAL": [1, 1],
					"NP2004_SMALL": [1, 0], "NP2004_GENERAL": [1, 1],
					"NP2026_SMALL": [1, 0], "NP2026_GENERAL": [1, 1],
					"UNION2010_GENERAL": [1, 1],
					"ENT2019_OLD_SMALL": [1, 0], "ENT2019_OLD_GENERAL": [1, 1],
					"ENT2019_NEW_SMALL": [1, 0], "ENT2019_NEW_GENERAL": [1, 1]
				};
				const m = map[val];
				if (m) {
					this.form.accountingStandards = String(m[0]);
					this.form.vatType = String(m[1]);
				}
			},
			remove(data) {
				this.showModal = true;
				this.rmData = data;
			},
			doRemove() {
				if (this.msgCode) {
					this.$Confirm("确认删除?").then(() => {
						this.$api.setting.accountSets.delete(this.rmData.id, this.msgCode).then(() => {
							this.loadList();
							this.$store.dispatch('init');
							this.showModal = false;
							this.rmData = {};
							this.msgCode = '';
						})
					})
				}
			},
			edit(row) {
				Api.setting.accountSets.checkUse(row.id).then(({data}) => {
					this.used = data;
					this.form = Object.assign({}, row);
					this.showForm = true;
				})
			},
			/* ===== 用户授权 ===== */
			grant(data) {
				this.grantData = data;
				this.grantForm = {mobile: '', role: 'Making'};
				this.showGrant = true;
			},
			doGrant() {
				if (!this.grantForm.mobile) {
					this.$Message('请输入用户手机号');
					return;
				}
				this.loading = true;
				this.$api.setting.accountSets.addUser(this.grantData.id, this.grantForm.mobile, this.grantForm.role).then(() => {
					this.$Message('授权成功');
					this.showGrant = false;
					this.loading = false;
				}).catch(() => {
					this.loading = false;
				})
			},
			/* ===== 续期 ===== */
			openRenew(data) {
				this.renewData = data;
				this.renewForm = {months: 12};
				this.showRenew = true;
			},
			doRenew() {
				this.loading = true;
				this.$api.setting.accountSets.renew({id: this.renewData.id, months: this.renewForm.months}).then(() => {
					this.$Message('续期成功');
					this.loadList();
					this.showRenew = false;
					this.loading = false;
				}).catch(() => {
					this.loading = false;
				})
			},
			/* ===== 停用/启用 ===== */
			toggleEnable(data) {
				const enable = data.status == 1; // 当前停用 -> 启用
				const tip = enable ? '启用' : '停用';
				this.$Confirm(`确认${tip}账套 ${data.companyName}?`).then(() => {
					this.$api.setting.accountSets.changeEnable({id: data.id, enabled: enable}).then(() => {
						this.$Message(`${tip}成功`);
						this.loadList();
					})
				})
			},
			/* ===== 重置（清空业务数据） ===== */
			openReset(data) {
				this.resetData = data;
				this.resetCode = '';
				this.showReset = true;
			},
			sendResetCode() {
				this.codeLoading = true;
				this.$api.common.sendMsg(this.User.mobile).then(() => {
					this.$Message('验证码已发送');
					this.codeLoading = false;
				}).catch(() => {
					this.codeLoading = false;
				})
			},
			doReset() {
				if (!this.resetCode) {
					return;
				}
				this.loading = true;
				this.$api.setting.accountSets.reset({id: this.resetData.id, smsCode: this.resetCode}).then(() => {
					this.$Message('重置成功，业务数据已清空');
					this.loadList();
					this.showReset = false;
					this.loading = false;
				}).catch(() => {
					this.loading = false;
				})
			}
		},
		mounted() {
			this.loadList();
		}
	};
</script>
